define.alias("shared/utils/number-helpers/compute-sign", "settings/utils/number-helpers/compute-sign");